import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0b59580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CalculatorForm" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold mt-3" }, "Укажите город отправлений и город прибытий", -1))
const _hoisted_3 = { class: "grid gap-3 grid-cols-2 mt-2" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 flex flex-col items-center justify-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-400 text-sm" }, "При загрузке направления произошла ошибка", -1))
const _hoisted_6 = { class: "grid grid-cols-2 gap-3 mt-2" }
const _hoisted_7 = { class: "CalculatorForm" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Дополнительные услуги", -1))
const _hoisted_9 = { class: "grid gap-3 grid-cols-3 items-center mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Мягкая упаковка", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Паллета", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Обрешетка", -1))
const _hoisted_13 = { class: "grid gap-3 grid-cols-4 items-start mt-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Манипулятор", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Кран", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Грузчики", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold" }, "Рохля", -1))
const _hoisted_18 = { class: "flex items-center justify-between mt-4" }
const _hoisted_19 = {
  key: 0,
  class: "text-red-400 text-sm"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calculator mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        disabled: _ctx.loading || _ctx.direction_state.is_loading,
        loading: _ctx.data_state.companies.is_loading || _ctx.direction_state.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний отправлений произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "search-without-refresh": "",
        label: "short_name",
        onRefresh: _ctx.loadCompanies
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_select, {
          placeholder: "Город отправлений",
          disabled: _ctx.loading || _ctx.direction_state.is_loading,
          loading: _ctx.data_state.from_cities.is_loading || _ctx.direction_state.is_loading,
          failed: _ctx.data_state.from_cities.is_failed,
          "error-text": "При получении списка городов отправлений произошла ошибка",
          options: _ctx.data_state.from_cities.list,
          "is-invalid": _ctx.state_form$.from_city.$error,
          "validation-errors": _ctx.state_form$.from_city.$errors,
          value: _ctx.state.from_city_id,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.from_city_id) = $event)),
          "search-without-refresh": "",
          onRefresh: _ctx.loadFromCities,
          onChange: _ctx.onFromCityChange
        }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
        _createVNode(_component_the_select, {
          placeholder: "Город прибытий",
          disabled: _ctx.loading || _ctx.direction_state.is_loading,
          loading: _ctx.data_state.where_cities.is_loading || _ctx.direction_state.is_loading,
          failed: _ctx.data_state.where_cities.is_failed,
          "error-text": "При получении списка городов прибытий произошла ошибка",
          options: _ctx.data_state.where_cities.list,
          "is-invalid": _ctx.state_form$.where_city.$error,
          "validation-errors": _ctx.state_form$.where_city.$errors,
          value: _ctx.state.where_city_id,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.where_city_id) = $event)),
          "search-without-refresh": "",
          onRefresh: _ctx.loadWhereCities,
          onChange: _ctx.onWhereCityChange
        }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"])
      ]),
      (_ctx.direction_state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_the_button, {
              class: "primary small mt-1",
              onClick: _ctx.loadDirection
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Перезагрузить ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_select, {
          placeholder: "Грузоподъемность",
          value: _ctx.state.volume,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.volume) = $event)),
          "is-invalid": _ctx.state_form$.volume.$error,
          "validation-errors": _ctx.state_form$.volume.$errors,
          disabled: _ctx.data_state.ftl_car_types.is_loading,
          loading: _ctx.data_state.ftl_car_types.is_loading,
          failed: _ctx.data_state.ftl_car_types.is_failed,
          "error-text": "При получении списка грузоподъемностей произошла ошибка",
          options: _ctx.data_state.ftl_car_types.list,
          label: "title",
          "search-by": "title",
          "select-by": "value",
          class: "mt-2",
          onRefresh: _ctx.loadFtlCarTypes
        }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options", "onRefresh"]),
        _createVNode(_component_the_input, {
          placeholder: "Отработанные часы",
          value: _ctx.state.duration,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.duration) = $event)),
          "is-invalid": _ctx.state_form$.duration.$error,
          "validation-errors": _ctx.state_form$.duration.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _hoisted_10,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Куб. метры",
            value: _ctx.state.additional_services.soft_package_value,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.additional_services.soft_package_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.soft_package_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.soft_package_value.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Куб. метры",
            value: _ctx.state.additional_services.pallet_value,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.additional_services.pallet_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.pallet_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.pallet_value.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Куб. метры",
            value: _ctx.state.additional_services.grid_value,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.additional_services.grid_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.grid_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.grid_value.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _hoisted_14,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Количество",
            value: _ctx.state.additional_services.manipulator_value,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.additional_services.manipulator_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_value.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.manipulator_duration,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.additional_services.manipulator_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_duration.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_duration.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Себестоимость за час",
            value: _ctx.state.additional_services.manipulator_costPerHour,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.additional_services.manipulator_costPerHour) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_costPerHour.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_costPerHour.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Количество",
            value: _ctx.state.additional_services.crane_value,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.additional_services.crane_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.crane_value.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.crane_duration,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.additional_services.crane_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_duration.$error,
            "validation-errors": _ctx.state_form$.additional_services.crane_duration.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Себестоимость за час",
            value: _ctx.state.additional_services.crane_costPerHour,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.additional_services.crane_costPerHour) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_costPerHour.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.crane_costPerHour.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_16,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Количество",
            value: _ctx.state.additional_services.loader_value,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.additional_services.loader_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.loader_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.loader_value.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.loader_duration,
            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.additional_services.loader_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.loader_duration.$error,
            "validation-errors": _ctx.state_form$.additional_services.loader_duration.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _createVNode(_component_the_input, {
            class: "mt-1",
            placeholder: "Количество",
            value: _ctx.state.additional_services.hydraulic_trolley_value,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.hydraulic_trolley_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_value.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            class: "mt-2",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.hydraulic_trolley_duration,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_duration) = $event)),
            "is-invalid": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_duration.$error
                        ,
            "validation-errors": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_duration.$errors
                        
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", null, [
          (_ctx.isDirectionMissing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " По выбранным городам не найдено активное направление "))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_the_button, {
          class: "primary small",
          type: "submit",
          disabled: _ctx.isDirectionMissing,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createTextVNode(" Рассчитать стоимость ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ], 32))
}